import { SearchUseCase } from '../../usecases';
import { API_BASE } from '../../constants';
import { makeHttpGet } from '../';
import { ISearchAsset } from '../../interfaces';

export const makeSearchAsset = () => {
  const url = `${API_BASE}/general/search`;
  const httpGet = makeHttpGet<ISearchAsset[]>();

  return new SearchUseCase<ISearchAsset>(url, httpGet);
};
